/**
 * Headers
 */
export const getTableHeaders = (dynamicColumns, hideColumns = []) => {
  return [
    'City',
    'Density',
    'Flyer Pack Size',
    'Total Packs',
    'Total Flyers',
    '# Missions',
    'Total Dist Cost',
    'Total Printing Cost',
    'Bonus Cost',
    'Total',
    ...dynamicColumns,
  ].filter(column => !hideColumns.includes(column))
}

/**
 * Columns that will be sortable
 */
export const getSortableColumns = (dynamicColumns, hideColumns = []) => {
  return [
    'City',
    'Density',
    'Flyer Pack Size',
    'Total Packs',
    'Total Flyers',
    '# Missions',
    'Total Dist Cost',
    'Total Printing Cost',
    'Bonus Cost',
    'Total',
    ...dynamicColumns,
  ].filter(column => !hideColumns.includes(column))
}

/**
 * Generates columns names from metrics
 * @param {array} metrics Campaign's metrics
 */
export const getColumnsFromMetrics = metrics =>
  metrics.reduce((acc, metric) => {
    if (metric.name) {
      acc.push(metric.name)
      acc.push(`${metric.name} CPM`)
    }
    return acc
  }, [])



// WEBPACK FOOTER //
// ./src/Components/CampaignQuote/settings.js